import { css } from '@emotion/react';
import type { CSSInterpolation } from '@emotion/serialize';
import type { ReactNode } from 'react';

import type { UnpluginIcon } from '@adflow/frontend/ui-assets';
import { theme, typography } from '@adflow/frontend/ui-theme';

const styles = {
	container: css({
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'center',
		width: '100%',
		height: '20rem',
	}),
	icon: css({
		width: '100%',
		height: '100%',
		marginLeft: 'auto',
		marginRight: 'auto',
		marginBottom: '2rem',
		maxWidth: '6.5rem',
		maxHeight: '6.5rem',
		color: theme.colors.text.hint,
	}),
	message: css(typography.emptyLarge, {
		textAlign: 'center',
		maxWidth: '40rem',
	}),
};

interface SimpleEmptySectionProps {
	Icon: UnpluginIcon;
	message: string | ReactNode;
	containerStyle?: CSSInterpolation;
}

export function SimpleEmptySection(props: SimpleEmptySectionProps) {
	return (
		<div css={[styles.container, props.containerStyle]}>
			<props.Icon css={styles.icon} />
			<div css={styles.message}>{props.message}</div>
		</div>
	);
}
